import { crearErrorAction } from "./ui";
import { types } from "../types/types"

// ─────────────────────────────────────────────────────────────────────────────
// NOU: 1 sola crida per tot el mes (fixatges + incidències + info resum)
// 1 sola crida POST /mes/detall en lloc de 3 crides separades
// ─────────────────────────────────────────────────────────────────────────────
export const recuperarDetallMesComplet = (token, dataIniciConsulta, dataFiConsulta) => {
    return (dispatch) => {
        dispatch({ type: types.calendariDetallMesLoading });

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': token
            },
            credentials: 'include',
            body: JSON.stringify({ dataIniciConsulta, dataFiConsulta })
        };

        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/mes/detall', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                if (response.status === 200 && data?.ok) {
                    dispatch({
                        type: types.calendariDetallMesComplet,
                        detallMes: data.contingut
                    });
                } else {
                    dispatch({ type: types.calendariDetallMesReset });
                    dispatch(crearErrorAction("Error carregant el mes: " + JSON.stringify(data)));
                }
            })
            .catch(error => {
                dispatch({ type: types.calendariDetallMesReset });
                console.error('recuperarDetallMesComplet error:', error);
            });
    };
};

// ─────────────────────────────────────────────────────────────────────────────
// Funcions antigues mantingudes per compatibilitat (vacances, setmana, etc.)
// ─────────────────────────────────────────────────────────────────────────────





export const recuperarVacancesEntreDates = (token, dataIniciConsulta, dataFiConsulta, llistatEmpresa, llistatTreb, llistatDep) => {
    return (dispatch) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors',
            body: JSON.stringify({ dataIniciConsulta, dataFiConsulta, llistatEmpresa, llistatTreb, llistatDep })
        };
        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/vacances/entreDates', requestOptions)
            .then(async response => {
                const data = response.headers.get('content-type')?.includes('application/json') && await response.json();
                if (response.status === 200 && data?.ok) dispatch(VacancesMesConsultat(data));
                else dispatch(crearErrorAction("Error vacances: " + JSON.stringify(data)));
            })
            .catch(error => {
                dispatch(crearErrorAction("Excepció vacances: " + JSON.stringify(error)));
                console.error(error);
            });
    };
};

export const recuperarInfoVacancesEntreDates = (token) => {
    return (dispatch) => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors'
        };
        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/vacances/infoEntreDates', requestOptions)
            .then(async response => {
                const data = response.headers.get('content-type')?.includes('application/json') && await response.json();
                if (response.ok && data?.ok) dispatch(VacancesInfoEntreDates(data));
            })
            .catch(error => console.error(error));
    };
};

// ─── Action creators ──────────────────────────────────────────────────────────
export const IncidenciaSemanaConsultada  = (llistatIncidenciaSemanaConsultada) => ({ type: types.calendariIncidenciaSemanaConsultada, llistatIncidenciaSemanaConsultada });
export const FixatgesSemanaConsultada    = (llistatFixatgesSemanaConsultada)    => ({ type: types.calendariFixatgesSemanaConsultada, llistatFixatgesSemanaConsultada });
export const VacancesMesConsultat        = (vacancesMesConsultat)               => ({ type: types.calendariVacancesMesConsultat, vacancesMesConsultat });
export const VacancesInfoEntreDates      = (vacancesInfo)                       => ({ type: types.calendariVacancesInfo, vacancesInfo });
export const IniciMesConsultat           = (inici)                              => ({ type: types.calendariIniciMesConsultat, inici });
export const FinalMesConsultat           = (final)                              => ({ type: types.calendariFinalMesConsultat, final });